module.exports = __webpack_public_path__ + "img/img12.27f1e7e3.png";